import Logo from "./assets/logo-light.svg";
import LogoPlainFull from "./assets/logo-plain-full.svg"
import PlaceholderPoster from "./assets/rectangle-poster.svg";
import PlaceholderBackdrop from "./assets/rectangle-backdrop.svg";

const
APP_NAME = "Dester - Libdrive",
APP_TITLE = "Dester is a frontend theme for libdrive",
APP_DESCRIPTION = "",
APP_LOGO = Logo,
APP_LOGO_PLAIN_FULL = LogoPlainFull,
APP_TYPE = "website",
PLACEHOLDER_POSTER = PlaceholderPoster,
PLACEHOLDER_BACKDROP = PlaceholderBackdrop;

export {
    APP_NAME,
    APP_TITLE,
    APP_DESCRIPTION,
    APP_LOGO,
    APP_LOGO_PLAIN_FULL,
    APP_TYPE,
    PLACEHOLDER_POSTER,
    PLACEHOLDER_BACKDROP
};